module.exports = __webpack_public_path__ + "static/img/content-img.92060523.png";